import { UNLIMITED_PAGINATION_PARAMS } from 'constants/pagination';
import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import qs from 'qs';
import { OrdersBulkUpdateData } from 'types/embedded/ordersBulkUpdate';
import { RoleOrderStatus } from 'types/embedded/role';

export type OrdersBulkUpdateResponse = {
  data: {
    found_ids: string[];
    not_found_ids: string[];
    not_allowed_ids: string[];
  };
};
export const ordersBulkUpdate = async (
  data: OrdersBulkUpdateData,
): Promise<OrdersBulkUpdateResponse> => {
  return axios
    .patch(Resources.OrdersBulkUpdate, data)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

type RoleOrderStatusResponse = { data: { statuses: RoleOrderStatus[] } };
export const getRoleOrderStatuses = async (): Promise<RoleOrderStatusResponse> => {
  const params = qs.stringify(
    {
      ...UNLIMITED_PAGINATION_PARAMS,
    },
    { arrayFormat: 'indices', encode: true },
  );
  return axios
    .get(`new/role_order_statuses?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.message));
};
